<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.state" :options="qstates" style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.credit_number" placeholder="授信编号" style="width:100%;">
      </a-input>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="getData">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <a-dropdown>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
          <a-menu-item @click="exportall">导出所有页</a-menu-item>
          <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
        </a-menu>
      </template>
      <a-button type="primary">
        导出数据
        <DownOutlined />
      </a-button>
    </a-dropdown>
  </div>
  <a-table bordered size="small" :columns="columns" :data-source="data" :loading="dataLoading"
    :scroll="{ x: width, y: 600 }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }" row-key="_id"
    :row-selection="{ selectedRowKeys, onChange: (keys) => selectedRowKeys = keys }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'amount'">
        {{ $filters.formatMoney(record.amount, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'apply_duration'">
        {{ getduration(record.apply_duration) }}
      </template>
      <template v-if="column.dataIndex === 'verify_date'">
        {{ record.verify_date || '-' }}
      </template>
      <template v-if="column.dataIndex === 'state'">
        <a-tag v-if="record.state === 0" class="tag-warning">待审批</a-tag>
        <a-tag v-if="record.state === 1" class="tag-success">审批通过</a-tag>
        <a-tag v-if="record.state === -1" class="tag-error">审批驳回</a-tag>
        <a-tag v-if="record.state >= 2" class="tag-success">已放款</a-tag>
        <p v-if="record.state === -1" class="text-error" style="font-size:12px;">
          {{ record.reason }}
        </p>
      </template>
      <template v-if="column.dataIndex === 'certificate'">
        <a-button type="link" v-if="record.certificate?.remoteurl">
          查看
        </a-button>
        <a-upload v-else :before-upload="(file) => beforeUpload(file, record._id)" :showUploadList="false"
          :disabled="dataLoading" accept=".jpg,.jpeg,.png">
          <a-button type="link"> 上传 </a-button>
        </a-upload>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a-button v-if="record.state === 0" type='link' class="text-error"
            @click="showAudit(record._id)">审核</a-button>
          <a-button v-if="record.state === 1" type='link' class="text-error" @click="showLoan(record)">放款</a-button>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="auditModal" title="审核" :maskClosable="!auditing" :closable="!auditing"
    @cancel="cancelAudit">
    <a-form ref="auditFormRef" name="auditForm" :model="auditForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="商户">
            {{ getorgname(auditForm.orgid) }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="授信编号">
            {{ auditForm.credit_number }}
          </a-form-item>
        </a-col>
        <template v-if="credit">
          <a-col :span="24">
            <a-form-item label="授信信息">
              <a-space>
                <span>额度(<span class="text-error">¥{{ credit.grant_quota }}</span>)</span>
                <span>已借款(<span class="text-success">¥{{ credit.loan_amount }}</span>)</span>
              </a-space>
            </a-form-item>
          </a-col>
        </template>
        <a-col :span="24">
          <a-form-item label="流水号">
            {{ auditForm.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="借款金额">
            <span class="text-error">{{ $filters.formatMoney(auditForm.amount, 2, '') }}</span>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="使用日期">
            {{ auditForm.apply_date }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="使用时长">
            {{ getduration(auditForm.apply_duration) }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="审核结果" name="state">
            <a-radio-group v-model:value="auditForm.state">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="-1">驳回</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="auditForm.state === -1">
          <a-form-item label="驳回原因" name="reason" :rules="[{ required: true, message: '请输入驳回原因' }]">
            <a-input v-model:value="auditForm.reason" placeholder="原因" :disabled="auditing"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template #footer>
      <div class="d-flex justify-end">
        <a-space>
          <a-button :disabled="auditing" @click="cancelAudit">取消</a-button>
          <a-button type="primary" :loading="auditing" @click="submitAudit">提交</a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
  <a-modal v-model:visible="loanModal" title="放款" :maskClosable="!loaning" :closable="!loaning" @cancel="cancelLoan">
    <a-form ref="loanFormRef" name="loanForm" :model="loanForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="商户">
            {{ getorgname(loanForm.orgid) }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="流水号">
            {{ loanForm.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="使用日期">
            {{ loanForm.apply_date }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="使用时长">
            {{ getduration(loanForm.apply_duration) }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="放款金额">
            <span class="text-error">{{ $filters.formatMoney(loanForm.amount, 2, '') }}</span>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="放款时间" name="verify_date" :rules="[{ required: true, message: '请选择放款时间' }]">
            <a-date-picker v-model:value="loanForm.verify_date" :locale="locale" :show-now="true"
              :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }" :show-today="true"
              value-format="YYYY-MM-DD HH:mm:ss" placeholder="放款时间" style="width:100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template #footer>
      <div class="d-flex justify-end">
        <a-space>
          <a-button :disabled="loaning" @click="cancelLoan">取消</a-button>
          <a-button type="primary" :loading="loaning" @click="submitLoan">提交</a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
</template>
<script setup>
import dayjs from "dayjs";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { DownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '授信编号', dataIndex: 'credit_number', width: 100 },
  { title: '流水号', dataIndex: 'number', width: 120 },
  { title: '商户名称', dataIndex: 'org', width: 150 },
  { title: '借款金额(¥)', dataIndex: 'amount', width: 120, },
  { title: '使用日期', dataIndex: 'apply_date', width: 120, },
  { title: '使用时长', dataIndex: 'apply_duration', width: 120, },
  { title: '状态', dataIndex: 'state', width: 100, },
  { title: '审核时间', dataIndex: 'audit_time', width: 120, },
  { title: '放款时间', dataIndex: 'verify_date', width: 150, },
  { title: '凭证', dataIndex: 'certificate', width: 120, },
  { title: '操作', dataIndex: 'operation', width: 150, fixed: "right" }
];
const { proxy } = getCurrentInstance();
const auditFormRef = ref();
const loanFormRef = ref();
const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  state: "ALL",
  credit_number: "",
});
const states = ref([
  { value: "0", label: "待审批" },
  { value: "1", label: "审批通过" },
  { value: "-1", label: "审批驳回" },
  { value: "2", label: "已放款" },
]);
const durations = ref([
  { value: 1, label: "1个月" },
  { value: 3, label: "3个月" },
  { value: 6, label: "6个月" },
  { value: 9, label: "9个月" },
  { value: 12, label: "1年" },
]);
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const orgs = ref([]);
const selectedRowKeys = ref([]);
const auditForm = ref({});
const auditModal = ref(false);
const auditing = ref(false);
const credits = ref([]);
const loanForm = ref({});
const loanModal = ref(false);
const loaning = ref(false);

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const credit = computed(() => {
  let data = _.findWhere(credits.value, { _id: auditForm.value.creditid });
  if (data) {
    data.grant_quota = proxy.$utils.formatMoney(data.grant_quota, 2, '');
    data.loan_amount = proxy.$utils.formatMoney(data.loan_amount, 2, '');
  }
  return data;
});
const qstates = computed(() => {
  return [
    { value: 'ALL', label: '全部' },
    ...states.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/loan/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          audit_time: n.audit_time ? proxy.$dateFormat(n.audit_time, 'YYYY-MM-DD HH:mm') : '-',
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const showAudit = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/loan/showaudit", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      credits.value = res.data.credits;
      auditForm.value = res.data.auditForm;
      auditModal.value = true;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const submitAudit = async () => {
  try {
    await auditFormRef.value.validateFields();
    auditing.value = true;
    proxy.$api.doAPI("/loan/audit", { dataForm: auditForm.value }).then((res) => {
      auditing.value = false;
      if (res.code === 0) {
        message.success("提交成功");
        auditModal.value = false;
        refresh();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      auditing.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
}
const cancelAudit = () => {
  auditFormRef.value.clearValidate();
  auditModal.value = false;
}
const showLoan = (item) => {
  loanForm.value = {
    _id: item._id,
    orgid: item.orgid,
    number: item.number,
    amount: item.amount,
    apply_date: item.apply_date,
    apply_duration: item.apply_duration,
    verify_date: '',
  };
  loanModal.value = true;
}
const submitLoan = async () => {
  try {
    await loanFormRef.value.validateFields();
    loaning.value = true;
    proxy.$api.doAPI("/loan/verify", { dataForm: loanForm.value }).then((res) => {
      loaning.value = false;
      if (res.code === 0) {
        message.success("提交成功");
        loanModal.value = false;
        refresh();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      loaning.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
}
const cancelLoan = () => {
  loanFormRef.value.clearValidate();
  loanModal.value = false;
}
const beforeUpload = (file, _id) => {
  console.log('beforeUpload');
  let checkresult = checkfile(file);
  if (checkresult.code != 0) return message.error(checkresult.msg);
  doUpload(file, _id);
};
const checkfile = (file) => {
  const valid_type = file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png";
  const valid_size = file.size / 1024 / 1024 < 2;
  if (!valid_type) {
    return { code: 1, msg: `只允许上传jpg,png图片` };
  }
  else if (!valid_size) {
    return { code: 1, msg: "文件不能超过2MB" };
  }
  return { code: 0 };
}
const doUpload = async (file, _id) => {
  dataLoading.value = true;
  const slicefiles = proxy.$utils.sliceFile(file.size);
  const faid = proxy.$utils.uuid();
  for (let i = 0; i < slicefiles.length; i++) {
    let slicefile = slicefiles[i];
    const formData = new FormData();
    if (slicefile.chunks > 1) {
      let _file = file.slice(slicefile.from, slicefile.to);
      formData.set("file", _file);
    } else {
      formData.set("file", file);
    }
    formData.set("faid", faid);
    formData.set("chunk", slicefile.chunk);
    formData.set("chunks", slicefile.chunks);
    formData.set("originalname", file.name);
    formData.set("loanid", _id);
    try {
      let res = await proxy.$api.doUpload("/loan/plupload", formData);
      if (res.code === 0) {
      } else {
        message.error(res.msg);
        break;
      }
    } catch (e) {
      console.error(e);
      message.error(e.message);
      break;
    }
  }
  console.log('doUpload-finished');
  dataLoading.value = false;
  getData();
}
const exportselected = () => {
}
const exportall = () => {
}
const exporttask = () => {

}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
const getduration = (value) => {
  return _.findWhere(durations.value, { value })?.label;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>